const DOCUMENT = 'DISTRICT_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  ADD_FAIL: DOCUMENT + 'ADD_FAIL',
  ADD_SUCCESS: DOCUMENT + 'ADD_SUCCESS',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  REVALIDATE_BANDING_MAPPINGS: DOCUMENT + 'REVALIDATE_BANDING_MAPPINGS',
  CHANGE_STEP: DOCUMENT + 'CHANGE_STEP',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  UPDATE_POSITIONS_REQUEST: DOCUMENT + 'UPDATE_POSITIONS_REQUEST',
  UPDATE_POSITIONS_SUCCESS: DOCUMENT + 'UPDATE_POSITIONS_SUCCESS',
  LOAD_CURRENT_POSITIONS: DOCUMENT + 'LOAD_CURRENT_POSITIONS',
  LOAD_CURRENT_POSITIONS_SUCCESS: DOCUMENT + 'LOAD_CURRENT_POSITIONS_SUCCESS',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_FUTURE_POSITIONS: DOCUMENT + 'LOAD_FUTURE_POSITIONS',
  LOAD_FUTURE_POSITIONS_SUCCESS: DOCUMENT + 'LOAD_FUTURE_POSITIONS_SUCCESS',
  LOAD_SECTOR_POSITIONS: DOCUMENT + 'LOAD_SECTOR_POSITIONS',
  LOAD_SECTOR_POSITIONS_SUCCESS: DOCUMENT + 'LOAD_SECTOR_POSITIONS_SUCCESS',
  LOAD_TIME_BANDS: DOCUMENT + 'LOAD_TIME_BANDS',
  LOAD_TIME_BANDS_SUCCESS: DOCUMENT + 'LOAD_TIME_BANDS_SUCCESS',
  EXPORT_CSV_POSITIONS: DOCUMENT + 'EXPORT_CSV_POSITIONS',
  IMPORT_CSV_POSITIONS: DOCUMENT + 'IMPORT_CSV_POSITIONS',
  IMPORT_CSV_POSITIONS_SUCCESS: DOCUMENT + 'IMPORT_CSV_POSITIONS_SUCCESS',
  IMPORT_CSV_POSITIONS_ERROR: DOCUMENT + 'IMPORT_CSV_POSITIONS_ERROR',
  TOGGLE_IMPORT_MODAL: DOCUMENT + 'TOGGLE_IMPORT_MODAL',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_FAIL: DOCUMENT + 'SAVE_FAIL',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SKIP_SECOND_STEP: DOCUMENT + 'SKIP_SECOND_STEP',
  TOUCH: DOCUMENT + 'TOUCH',
  SECTOR_REVERT_TO_BASE_RATE: DOCUMENT + 'SECTOR_REVERT_TO_BASE_RATE',
  BULK_UPDATE_SECTOR_POSITION_RATES: DOCUMENT + 'BULK_UPDATE_SECTOR_POSITION_RATES',
  UPDATE_POSITION_STATUS_REQUEST: DOCUMENT + 'UPDATE_POSITION_STATUS_REQUEST',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',

  add: data => ({ type: actions.ADD, payload: data }),
  addFail: data => ({ type: actions.ADD_FAIL, payload: data }),
  addSuccess: data => ({ type: actions.ADD_SUCCESS, payload: data }),
  cancel: data => ({ type: actions.CANCEL, payload: data }),
  changeNestedProperty: data => ({ type: actions.CHANGE_NESTED_PROPERTY, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  revalidateBandingMappings: () => ({ type: actions.REVALIDATE_BANDING_MAPPINGS }),
  changeStep: data => ({ type: actions.CHANGE_STEP, payload: data }),
  clearStore: data => ({ type: actions.CLEAR_STORE, payload: data }),
  create: data => ({ type: actions.CREATE, payload: data }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  loadCurrentPositions: data => ({ type: actions.LOAD_CURRENT_POSITIONS, payload: data }),
  loadCurrentPositionsSuccess: data => ({ type: actions.LOAD_CURRENT_POSITIONS_SUCCESS, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  loadFuturePositions: data => ({ type: actions.LOAD_FUTURE_POSITIONS, payload: data }),
  loadFuturePositionsSuccess: data => ({ type: actions.LOAD_FUTURE_POSITIONS_SUCCESS, payload: data }),
  loadSectorPositions: data => ({ type: actions.LOAD_SECTOR_POSITIONS, payload: data }),
  loadSectorPositionsSuccess: data => ({ type: actions.LOAD_SECTOR_POSITIONS_SUCCESS, payload: data }),
  loadTimeBands: () => ({ type: actions.LOAD_TIME_BANDS }),
  loadTimeBandsSuccess: data => ({ type: actions.LOAD_TIME_BANDS_SUCCESS, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveFail: data => ({ type: actions.SAVE_FAIL, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  exportCsvPositions: data => ({ type: actions.EXPORT_CSV_POSITIONS, payload: data }),
  importCsvPositions: data => ({ type: actions.IMPORT_CSV_POSITIONS, payload: data }),
  importCsvPositionsSuccess: () => ({ type: actions.IMPORT_CSV_POSITIONS_SUCCESS }),
  importCsvPositionsError: () => ({ type: actions.IMPORT_CSV_POSITIONS_ERROR }),
  toggleImportModal: data => ({ type: actions.TOGGLE_IMPORT_MODAL, payload: data }),
  sectorRevertToBaseRate: data => ({ type: actions.SECTOR_REVERT_TO_BASE_RATE, payload: data }),
  bulkUpdateSectorPositionRates: data => ({ type: actions.BULK_UPDATE_SECTOR_POSITION_RATES, payload: data }),
  updatePositionStatus: data => ({ type: actions.UPDATE_POSITION_STATUS_REQUEST, payload: data }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  updatePositions: data => ({ type: actions.UPDATE_POSITIONS_REQUEST, payload: data }),
};

export default actions;
